<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      采购订单管理
      <small>/采购单列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">采购单列表</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
              <div>
              <form  style="margin-top:16px;" >
                <fieldset>
            <div class="form-group row m-b-15">
                   <label class="col-md-1 col-form-label">采购单号</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="采购单号"
                        v-model="form.orderNo"
                      >
                    </div>

                  <label class="col-md-1 col-form-label">采购单状态</label>
                  <div class="col-md-2">
                        <el-select
                          v-model="orderStatus"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in status "
                            :key="item.code "
                            :label="item.name"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </div>
                  <label class="col-md-1 col-form-label">下单时间</label>
                     <div class="col-md-3">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                        style="float:right;"
                      >查询</a>
                    </div>
                    <div class="col-md-11"></div>
                    <div  class="col-md-1">
                    <el-button
                      class="btn btn-primary btn-sm m-l-1 ButtonColor bot-btn-left a_class"
                      @click="addClick()"
                    >新增</el-button>
                  </div>
            </div>
            </fieldset>
        </form>
                <div class="div_class_table">
                    <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="orderNo"
                        label="订单编号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="recomTypeNames"
                        label="客户类型"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                       <el-table-column
                        prop="recomName"
                        label="客户名称"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="orderCount"
                        label="下单数量"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="orderPrice"
                        label="下单金额"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="inputTime"
                        label="下单时间"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="orderStatusName"
                        label="订单状态"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        prop="fileUrl"
                        label="支付凭证"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <div class="demo-image__preview">
                            <el-image
                              style="width: 50px; height: 50px"
                              :src="scope.row.fileUrl"
                              @click="openImg(scope.row.fileUrl)"
                            ></el-image>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                       
                        label="操作"
                        align="center"
                        resizable
                        fit    
                        fixed="right"
                      >
                        <template slot-scope="scope">
                          <el-button
                            class="btn btn-warning btn-sm ButtonColor"
                            size="small"
                            @click="deleteClick(scope.row)"
                          >删除</el-button>
                          <el-button
                            @click="modifyClick(scope.row,scope.$index+1)"
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                          >编辑</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
   <el-dialog title :visible.sync="outerVisible" width="500px">
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSure"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "top",
  data() {
    return {
      // 对话框
      dialogImgUrl: "",
      imgVisible: false,
      disabled: false,
      EditDialog: 1,
      outerVisible: false,
      // 当前页  ---- 默认显示第几页
      // current: 1,
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,
      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        // 商品名称
        goodsName: "",
        // 料号
        pznCode: "",
        // 商品名称
        goodname: "",
        // 条形码
        barCode: "",
        // 服务商
        fws: "",
        //  订单类型
        listtype: "",
        orderStatus:""
      },
      orderStatus:"",
      //  商品名称
      goodsName: "",
      status:"",
      //  订单状态
      orderStatus: [
        {
          value: "0",
          label: "拒绝审核"
        },
        {
          value: "1",
          label: "待审核"
        },
        {
          value: "2",
          label: "审核通过"
        }
      ],
        TimeValue:"",
    
      //   表格的 数据
      tableData3: [],
      director:0
      //
    };
  },
  mounted() {
       // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      let that = this;
      const options = {
        // top订单管理
        url: "/distribution/B2cTobOrderController/queryOrderPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          recomId: that.form.recomId,
          orderStatusList: [0,1],
          orderNo:that.form.orderNo,
          startInputTime: that.startTime,
          endInputTime: that.endTime,
          director:that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          for (var i = 0; i < response.data.data.records.length; i++) {
            response.data.data.records[i].goodsid =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
          }
        // 审核状态：0-拒绝，2-通过
          for (var a of response.data.data.records) {
            if (a.orderStatus == 2) {
              a.orderStatusName = "审核通过";
            }
            if (a.orderStatus == 1) {
              a.orderStatusName = "未审核";
            }
            if (a.orderStatus == 0) {
                a.orderStatusName = "审核拒绝";
            }
            if (a.recomType == 2) {
               a.recomTypeNames = "服务商";
            }
            if (a.recomType == 1) {
              a.recomTypeNames = "分销商";
            }
          }
          this.tableData3 = response.data.data.records;
          this.totalCount = response.data.data.total;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
      // 新增
    addClick() {
      this.$router.push({ name: "topOrderAddList", path: "/toporderaddlist" });
    },

    openImg(url) {
      if (url) {
        this.imgVisible = true;
        this.dialogImgUrl = url;
      }
    },

    // 查询数据
    SearchClick() {
      this.pageNo = 1
      this.initData();
    },

    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/orderExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {}
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/orderExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {},
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "TOP订单列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    // 删除的 处理函数
    deleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
   

    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "删除") {
        let that = this;
        that.outerVisible = false;
        that.disabled = false;
        const options = {
          url: "/distribution/B2cTobOrderController/checkOrder",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            orderStatus:1,
            orderNo: that.ruleForm.orderNo
          })
        };
        axios(options)
          .then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.initData();
              that.$notify({
                title: "成功",
                message: "删除成功",
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            that.outerVisible = false;
            that.disabled = false;
            http.handleHttpError(error, that);
          });

        //
      }
    },
    jujue(formName) {
      this.innerVisible = true;
      // this.outerVisible = false;
      this.$prompt("理由：", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /./g,
        inputPlaceholder: "请输入拒绝审核理由",
        inputErrorMessage: "请输入拒绝审核理由"
      })
        .then(({ value }) => {
          let that = this;
          that.outerVisible = false;
          that.disabled = false;
          const options = {
            url: "/distribution/B2cTobOrderController/checkOrder",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              orderStatus: 0,
              orderNo: that.ruleForm.orderNo,
              auditReason: value
            })
          };
          axios(options)
            .then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initData();
                that.$notify({
                  title: "成功",
                  message: "拒绝审核",
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function(error) {
              that.outerVisible = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });

          this.outerVisible = false;
        })
        .catch(() => {
          this.outerVisible = true;
        });
    },
    // 对话框的 【确定 】 处理函数
    MakeSure() {
      this.outerVisible = true;
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    },
        
    modifyClick(item) {
      this.$router.push({ name: "topOrderAddListModify", path: "/toporderaddListmodify"});
       localStorage.setItem(
        "goodlist",
        JSON.stringify({
          orderNo: item.orderNo,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          urlImage:item.url,
          orderPrice:item.orderPrice
        })
      );
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 20px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  /* margin-top: 50px; */
  padding-right: 30px;
  letter-spacing: 1px;
}
/*  */
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.a_class {
  padding: 8px 12px;
}
.div_tab {
  margin-top: 6%;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.right_but {
  float: right;
  margin-top: 38px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
}
.bot-btn {
  float: left;
  margin-left: 20.42%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
.top-input {
  margin-left: 25px;
}
.border-main {
  width: 400px;
  height: 80px;
  margin-left: 20%;
}
.border-main > h5 {
  color: #161a1e;
  font-size: 15px;
  margin-top: 15%;
}
.border-main > h5 b {
  color: #e4393c;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/top.vue